<cache-date></cache-date>

<div class="container">
	<h1>{{ 'adminstat.support.cache_info.admin cache_info' | translate }}</h1>
	<hr><br><br>
	
	<ng-container *ngIf="pause && pause.status === false">
		<div *ngFor="let process of list" class="row">
			<div class="col-md-12" *ngIf="process.pid">
				<b>pid: {{process.pid}}</b>
				<br>
				
				<div *ngIf="process.name">
					<div class="progress">
						<div class="progress-bar progress-bar-striped active" role="progressbar" attr.aria-valuenow="{{process.mainPercent}}" aria-valuemin="0" aria-valuemax="100" [ngStyle]="{'width': process.mainPercent + '%'}">
							{{process.mainPercent.toFixed(2)}}%
						</div>
					</div>
				</div>
				
				<p>{{ 'adminstat.support.cache_info.rebuild' | translate }} <b>{{process.ns}}</b> - count: {{process.currentCount}}/{{process.totalCount}}
				<p>{{ 'adminstat.support.cache_info.start time' | translate }} {{process.start}}</p>
				
				<div class="progress">
					<div class="progress-bar progress-bar-striped active" role="progressbar" attr.aria-valuenow="{{process.percent}}" aria-valuemin="0" aria-valuemax="100" [ngStyle]="{'width': process.percent + '%'}">
						{{process.percent.toFixed(2)}}%
					</div>
				</div>
				
				<br><br><br>
				
				<button (click)="killProcess(process.pid, process.main)" class="btn btn-mini btn-danger">
					{{ 'adminstat.support.cache_info.kill process' | translate }}
				</button>
							
				<br><hr><br>
			</div>
		</div>
	</ng-container>
	
	<ng-container *ngIf="pause && pause.status === false">
		<button type="button" class="btn btn-mini btn-success" (click)="startRebuilding()">
			{{ 'adminstat.support.cache_info.start process' | translate }}
		</button>
		
		<button type="button" class="btn btn-danger" (click)="pauseRebuilding()">
			{{ 'adminstat.support.cache_info.pause process' | translate }}
		</button>
	</ng-container>

	<ng-container *ngIf="pause && pause.status === true">
		<h2>{{ 'adminstat.support.cache_info.rebuilding paused' | translate }} {{ pause.date }} ({{ pause.email }})</h2>
		
		<br><br>
		
		<button type="button" class="btn btn-warning" (click)="resumeRebuilding()">
			{{ 'adminstat.support.cache_info.resume process' | translate }}
		</button>		
	</ng-container>
</div>
